<ng-content ></ng-content>


// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/chips/chip-notResponsive/chip-notResponsive.component.html